import React from "react";
import { Grid, TextField, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// Define validation schema for all fields in the PersonalDetails form
const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    middleName: Yup.string().required("Middle name is required"),
    lastName: Yup.string().required("Last name is required"),
    userName: Yup.string().required("Username is required"),
    password: Yup.string().min(6, "Password should be at least 6 characters").required("Password is required"),
    userPan: Yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format").required("User PAN is required"),
    aadhaarNumber: Yup.string().matches(/^[0-9]{12}$/, "Invalid Aadhaar Number").required("Aadhaar Number is required"),

});

const PersonalDetails = ({ initialValues, onNext }) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onNext(values)}
        >
            {({ values, errors, touched, handleChange }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="First Name"
                                name="firstName"
                                value={values.firstName}
                                onChange={handleChange}
                                error={Boolean(errors.firstName && touched.firstName)}
                                helperText={touched.firstName && errors.firstName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Middle Name"
                                name="middleName"
                                value={values.middleName}
                                onChange={handleChange}
                                error={Boolean(errors.middleName && touched.middleName)}
                                helperText={touched.middleName && errors.middleName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Last Name"
                                name="lastName"
                                value={values.lastName}
                                onChange={handleChange}
                                error={Boolean(errors.lastName && touched.lastName)}
                                helperText={touched.lastName && errors.lastName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Username"
                                name="userName"
                                value={values.userName}
                                onChange={handleChange}
                                error={Boolean(errors.userName && touched.userName)}
                                helperText={touched.userName && errors.userName}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Password"
                                name="password"
                                type="password"
                                value={values.password}
                                onChange={handleChange}
                                error={Boolean(errors.password && touched.password)}
                                helperText={touched.password && errors.password}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="User PAN"
                                name="userPan"
                                value={values.userPan}
                                onChange={handleChange}
                                error={Boolean(errors.userPan && touched.userPan)}
                                helperText={touched.userPan && errors.userPan}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Aadhaar Number"
                                name="aadhaarNumber"
                                value={values.aadhaarNumber}
                                onChange={handleChange}
                                error={Boolean(errors.aadhaarNumber && touched.aadhaarNumber)}
                                helperText={touched.aadhaarNumber && errors.aadhaarNumber}
                            />
                        </Grid>

                    </Grid>
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Next
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default PersonalDetails;
